import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { SHeaderComponent } from "../../shared/s-header/s-header.component";
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { BaseFaqItemComponent } from "./base-faq-item/base-faq-item.component";

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
  isExpanded?: boolean;
}

export interface FaqData {
  id?: string;
  title: string;
  subtitle: string;
  faqs: FaqItem[];
}

@Component({
  selector: 'app-c-faq',
  imports: [
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    SHeaderComponent,
    BaseFaqItemComponent
],
  templateUrl: './c-faq.component.html',
  styleUrl: './c-faq.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CFaqComponent extends CBaseComponent implements OnInit {
  override ngOnInit() {
      this.singleLabels = [ElementsType.ComponentHeader];
      this.groupLabels = [ElementsType.FaqItems];
      super.ngOnInit();
  }
}
